import { useMemo } from 'react';
import { useTranslation } from '@frontend/i18n';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { useCalendarHeaderContext } from '../../../../context/calendar-header-context';
import { useCalendarV3ShallowStore } from '../../../../stores/use-calendar-v3-store';
import { useScheduleActionsAppointmentListInfoShallowStore } from '../../../../stores/use-schedule-actions-appointment-list-store';
import { CALENDAR_TRACKING_IDS } from '../../../../trackingIds/calendar-tracking-ids';
import { openSchedulePulse, SchedulePulseTab } from '../../../../utils';
import { QuickFilters, QuickFilterKey, ListItem } from './quick-filters';

export const QuickFiltersContainer = () => {
  const { t } = useTranslation('schedule');
  const isMedium = useMatchMedia({ maxWidth: breakpoints.mobile.max });
  const isSmall = useMatchMedia({ maxWidth: breakpoints.xsmall.max });
  const { calendarEventsCount, unconfirmedCalendarEventsCount } = useCalendarHeaderContext();
  const { calendarDate } = useCalendarV3ShallowStore('calendarDate');
  const { setSelectedDate, setStatusFilter, setHasActiveFilters } = useScheduleActionsAppointmentListInfoShallowStore(
    'setSelectedDate',
    'setStatusFilter',
    'setHasActiveFilters'
  );

  const handleSelection = (filter: QuickFilterKey) => {
    openSchedulePulse(SchedulePulseTab.AppointmentList);
    setSelectedDate(calendarDate);
    setStatusFilter(filter !== QuickFilterKey.All ? filter : '');
    setHasActiveFilters(filter !== QuickFilterKey.All);
  };

  const quickFilterList = useMemo<ListItem[]>(
    () => [
      {
        key: QuickFilterKey.All,
        label: t('Appointments'),
        iconName: 'calendar',
        count: calendarEventsCount,
        trackingId: CALENDAR_TRACKING_IDS.headerBar.allAppointmentsCountButton,
      },
      {
        key: QuickFilterKey.Unconfirmed,
        label: t('Unconfirmed'),
        iconName: 'pending',
        count: unconfirmedCalendarEventsCount,
        trackingId: CALENDAR_TRACKING_IDS.headerBar.unconfirmedAppointmentsCount,
      },
    ],
    [calendarEventsCount, t, unconfirmedCalendarEventsCount]
  );

  if (isSmall) {
    return null;
  }

  return (
    <QuickFilters variant={isMedium ? 'dropdown' : 'card'} list={quickFilterList} onSelectHandler={handleSelection} />
  );
};
